import { BodyRenderExternalData } from '~/components/BodyRender/models';
import { SplitterProps } from '~/components/Splitter/models';

export const splitterMapper = (
  splitter: SplitterProps | null,
  _currentPageUid: string,
  externalData?: BodyRenderExternalData
): SplitterProps | undefined => {
  if (!splitter) return undefined;

  return { ...splitter, externalData };
};
